import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CustomerDebtPaymentItemForm from "../create/components/CustomerDebtPaymentItemForm";
import CustomerDebtPaymentJournalForm from "../create/components/CustomerDebtPaymentJournalForm";
import CustomerDebtPaymentItemEditForm from "../edit/components/CustomerDebtPaymentItemForm";
import CustomerDebtPaymentJournalEditForm from "../edit/components/CustomerDebtPaymentJournalForm";
import { useState } from "react";
import { useTheme, useTranslate } from "react-admin";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  );
}

const TabForm = ({ schema, ...props }) => {
  const t = useTranslate();
  const [value, setValue] = useState(0);

  const [theme] = useTheme("light");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const bgcolor = theme !== "dark" ? "grey.200" : "grey.800";
  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          bgcolor: "background.paper",
          mb: 1,
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="fullWidth"
        >
          <Tab
            label={t("mine.label.payment")}
            sx={value === 0 ? { bgcolor } : {}}
          />
          <Tab
            label={t("mine.label.journal")}
            sx={value === 1 ? { bgcolor } : {}}
          />
        </Tabs>
      </Box>
      {schema === "edit" ? (
        <>
          <TabPanel value={value} index={0}>
            <CustomerDebtPaymentItemEditForm />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <CustomerDebtPaymentJournalEditForm />
          </TabPanel>
        </>
      ) : (
        <>
          <TabPanel value={value} index={0}>
            <Box
                            sx={{
                              maxHeight: '300px', // Sesuaikan tinggi maksimum sesuai kebutuhan Anda
                              overflowY: 'auto',
                              border: '1px solid #ccc', // Opsional: untuk visualisasi batas
                              borderRadius: '4px',
                              marginBottom: '24px',
                              p: 1, // Opsional: padding
                            }}
                          >
            <CustomerDebtPaymentItemForm />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Box
                sx={{
                  maxHeight: '300px', // Sesuaikan tinggi maksimum sesuai kebutuhan Anda
                  overflowY: 'auto',
                  border: '1px solid #ccc', // Opsional: untuk visualisasi batas
                  borderRadius: '4px',
                  marginBottom: '24px',
                  p: 1, // Opsional: padding
                }}
              >
            <CustomerDebtPaymentJournalForm />
            </Box>
          </TabPanel>
        </>
      )}
    </Box>
  );
};

export default TabForm;
